import React from "react";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Title from "../../ui/title";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { RadioGroup, Divider, Grid, Radio } from "material-ui";
import Content from "../../ui/content";
import { withStyles } from "material-ui/styles";
import Input, { InputLabel } from "material-ui/Input";
import styles from "./styles";
import SearchTarget from "../common/searchTarget";
import ConfirmDialog from "../../common/dialog/confirm";
import { validateFormData } from "../../../common/formtool";

import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { withRouter } from "react-router-dom";
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import {
  BandWidthTypeEnum,
  CertaintyEnum,
  FrameSizeEnum,
  DurationEnum
} from "./uptimeenum";

import NoData from "../../nodata";

class UpTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upTime: this.props.upTime,
      isChanged: false,
      showConfirmBack: false,
      errors: {},
      bandwidthtype: [],
      certainty: [],
      desiredbandwidth: "",
      desiredbandwidthpercenatge: "",
      desireduptimecertainty: "",
      duration: "",
      durH: "",
      durM: "",
      durS: "",
      expectedtotalbandwidth: "",
      expectedusablebandwidth: "",
      framesize: [],
      limitpercentage: "",
      linkspeed: null,
      networkoverhead: "",
      showRestoreConfirm: false,
      isUpTimeUpdated: false
    };
    this.onChange = this.onChange.bind(this);
    this.onUpTimeSave = this.onUpTimeSave.bind(this);
  }
  componentWillMount() {
    this.props.getUpTime();
  }
  componentWillUnmount() {
    this.setState({ upTime: null });
  }
  componentWillReceiveProps(nextProps) {
    const { upTime, uptimedetails, isTestEdit } = nextProps;

    if (isTestEdit && !uptimedetails) {
      if (upTime && this.props.upTime != upTime) {
        this.updateUpTimeState(upTime);
      }
    } else if (isTestEdit && uptimedetails) {
      if (
        (uptimedetails && this.props.uptimedetails != uptimedetails) ||
        !this.state.isUpTimeUpdated
      ) {
        this.updateUpTimeState(uptimedetails);
        this.setState({ isUpTimeUpdated: true });
      }
    } else {
      if (upTime && this.props.upTime != upTime) {
        this.updateUpTimeState(upTime);
      }
    }
  }

  onUpTimeSave = () => {
    let { translate, isTestEdit } = this.props;
    let {
      bandwidthtype,
      linkspeed,
      desiredbandwidth,
      desiredbandwidthpercenatge,
      duration,
      desireduptimecertainty,
      limitpercentage,
      framesize,
      expectedtotalbandwidth,
      expectedusablebandwidth,
      networkoverhead,
      certainty
    } = this.state;
    let vObj = {
      bandwidthtype: {
        required: translate("formfield_error_general_required")
      },
      linkspeed: {
        required: translate("formfield_error_general_required")
      },
      desiredbandwidth: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 0,
          maxValue: 10000,
          message: translate("sub_test_ping_validation_range", {
            name: translate("uptime_desired_bandwidth"),
            value1: 0,
            value2: 10000
          })
        },
        type: {
          value: "numeric",
          message: translate("subtest_numeric_validation", {
            name: translate("uptime_desired_bandwidth")
          })
        }
      },
      desiredbandwidthpercenatge: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 0,
          maxValue: 100,
          message: translate("sub_test_ping_validation_range", {
            name: translate("uptime_bandwidth_per"),
            value1: 0,
            value2: 100
          })
        },
        type: {
          value: "numeric",
          message: translate("subtest_numeric_validation", {
            name: translate("uptime_bandwidth_per")
          })
        }
      },
      duration: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 10,
          maxValue: 259200,
          message: translate("sub_test_ping_validation_range", {
            name: translate("uptime_duration"),
            value1: 10,
            value2: 259200
          })
        }
      },
      certainty: {
        required: translate("formfield_error_general_required")
      },
      limitpercentage: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 0.001,
          maxValue: 100,
          message: translate("sub_test_ping_validation_range", {
            name: translate("uptime_limit_per"),
            value1: 0.001,
            value2: 100
          })
        },
        type: {
          value: "decimal2",
          message: translate("uptime_limit_percentage_numeric_error")
        }
      },
      framesize: {
        required: translate("formfield_error_general_required")
      },
      expectedtotalbandwidth: {
        required: translate("formfield_error_general_required")
      },
      expectedusablebandwidth: {
        required: translate("formfield_error_general_required")
      },
      networkoverhead: {
        required: translate("formfield_error_general_required")
      }
    };

    let errors = validateFormData(
      {
        bandwidthtype,
        linkspeed,
        desiredbandwidth,
        desiredbandwidthpercenatge,
        duration,
        certainty,
        limitpercentage,
        framesize,
        expectedtotalbandwidth,
        expectedusablebandwidth,
        networkoverhead
      },
      vObj
    );
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let self = this;
      const details = {
        id: this.props.upTime.id,
        organisationid: this.props.upTime.organisationid,
        bandwidthtype: bandwidthtype,
        linkspeed: linkspeed,
        desiredbandwidth: desiredbandwidth,
        desiredbandwidthpercenatge: desiredbandwidthpercenatge,
        framesize: framesize,
        desireduptimecertainty: desireduptimecertainty,
        duration: duration,
        certainty: certainty,
        limitpercentage: isTestEdit ? Number(limitpercentage) : limitpercentage,
        expectedtotalbandwidth: expectedtotalbandwidth,
        expectedusablebandwidth: expectedusablebandwidth,
        networkoverhead: networkoverhead
      };
      this.setState({
        isChanged: false
      });
      //this.props.updateSubTestUptime(details);
      if (isTestEdit) {
        this.props.updateUpTime(this.props.selectedTest, details);
        this.props.handleClose();
      } else {
        this.props.updateSubTestUptime(details);
      }
      if (this.state.isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
    }
  };

  formCalculation = (frameSize, overHead, desiredbandwidth) => {
    let framePerSec =
      (desiredbandwidth * 1000000) / (8 * (frameSize + overHead));
    let expectedtotalbandwidth =
      (framePerSec * (frameSize + overHead) * 8) / 1000000000;
    let networkoverhead = (framePerSec * 24 * 8) / 1000000000;
    let expectedusablebandwidth = expectedtotalbandwidth - networkoverhead;
    this.setState({
      expectedtotalbandwidth: Number(expectedtotalbandwidth.toFixed(4)),
      networkoverhead: Number(networkoverhead.toFixed(4)),
      expectedusablebandwidth: Number(expectedusablebandwidth.toFixed(4))
    });
  };

  updateUpTimeState = upTime => {
    this.setState({
      bandwidthtype: upTime.bandwidthtype,
      linkspeed: upTime.linkspeed,
      desiredbandwidth: upTime.desiredbandwidth,
      desiredbandwidthpercenatge: upTime.desiredbandwidthpercenatge,
      certainty: upTime.certainty,
      desireduptimecertainty: upTime.desireduptimecertainty,
      duration: this.formatDuration(upTime.duration),
      framesize: upTime.framesize,
      limitpercentage: upTime.limitpercentage.toFixed(3)
    });
    let frameValue = Number(
      FrameSizeEnum.filter(res => res.value == upTime.framesize)[0].key
    );
    this.formCalculation(frameValue, 20, upTime.desiredbandwidth);
  };

  formatDuration = duration => {
    let sec_num = parseInt(duration, 10);
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    this.setState({
      durH: hours,
      durM: minutes,
      durS: seconds
    });
    return duration;
  };

  onDurationChange = e => {
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      duration: false
    };
    const { durH, durM, durS } = this.state;
    let updatedDuration = null;
    if (e.target.name == "durH")
      updatedDuration = [e.target.value, durM, durS].reduce(
        (acc, time) => 60 * acc + +time
      );
    else if (e.target.name == "durM")
      updatedDuration = [durH, e.target.value, durS].reduce(
        (acc, time) => 60 * acc + +time
      );
    else
      updatedDuration = [durH, durM, e.target.value].reduce(
        (acc, time) => 60 * acc + +time
      );

    this.formatDuration(updatedDuration);
    this.setState({
      duration: updatedDuration,
      // [e.target.name]:
      //   e.target.value >= 0 && e.target.value < 10
      //     ? "0" + e.target.value
      //     : e.target.value,
      isChanged: true,
      errors,
      isRestore: false
    });
  };

  onChange = e => {
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if ([e.target.name] == "bandwidthtype") {
      if ([e.target.value] == 0) {
        errors = {
          ...errors,
          desiredbandwidth: false
        };
        this.setState({
          desiredbandwidth: this.props.upTime.desiredbandwidth,
          errors
        });
      }
      if ([e.target.value] == 1) {
        errors = {
          ...errors,
          desiredbandwidthpercenatge: false
        };
        this.setState({
          desiredbandwidthpercenatge: this.props.upTime
            .desiredbandwidthpercenatge,
          errors
        });
      }
    }
    if ([e.target.name] == "desireduptimecertainty" && [e.target.value] == 1) {
      if ([e.target.value] == 1) {
        let updatedDuration = DurationEnum.filter(
          res => res.key == this.state.certainty
        );
        this.formatDuration(updatedDuration[0].value);
        this.setState({
          [e.target.name]:
            e.target.value == 0
              ? e.target.value
              : Number(e.target.value)
                ? Number(e.target.value)
                : "",
          duration: updatedDuration[0].value,
          isChanged: true,
          errors
        });
      } else if ([e.target.value] == 0) {
        this.setState({
          [e.target.name]:
            e.target.value === 0 ? e.target.value : Number(e.target.value),
          isChanged: true,
          errors
        });
      }
    } else if ([e.target.name] == "certainty") {
      let updatedDuration = DurationEnum.filter(
        res => res.key == e.target.value
      );
      this.formatDuration(updatedDuration[0].value);
      this.setState({
        [e.target.name]:
          e.target.value == 0 ? e.target.value : Number(e.target.value),
        duration: updatedDuration[0].value,
        isChanged: true,
        errors
      });
    } else if ([e.target.name] == "framesize") {
      let frameValue = Number(
        FrameSizeEnum.filter(res => res.value == e.target.value)[0].key
      );
      this.formCalculation(frameValue, 20, this.state.desiredbandwidth);
      this.setState({
        [e.target.name]:
          e.target.value == 0 ? e.target.value : Number(e.target.value),
        isChanged: true,
        errors
      });
    } else if ([e.target.name] == "desiredbandwidth") {
      let frameValue = Number(
        FrameSizeEnum.filter(res => res.value == this.state.framesize)[0].key
      );
      this.formCalculation(
        frameValue,
        20,
        Number(e.target.value) ? Number(e.target.value) : 0
      );
      this.setState({
        [e.target.name]:
          e.target.value == 0
            ? e.target.value
            : Number(e.target.value)
              ? Number(e.target.value)
              : "",
        isChanged: true,
        errors
      });
    } else if ([e.target.name] == "limitpercentage") {
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        errors
      });
    } else {
      this.setState({
        [e.target.name]:
          e.target.value == 0
            ? e.target.value
            : Number(e.target.value)
              ? Number(e.target.value)
              : "",
        isChanged: true,
        errors
      });
    }
    this.setState({ isRestore: false });
  };
  onCertaintyChange = e => {
    let { desireduptimecertainty } = this.state;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      desireduptimecertainty: false
    };

    this.setState({
      desireduptimecertainty: desireduptimecertainty == 1 ? 0 : 1,
      isChanged: true,
      errors,
      isRestore: false
    });
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  onRestoreConfirm = () => {
    //this.props.updateUpTime(this.props.selectedTest, this.props.upTime);
    this.updateUpTimeState(this.props.upTime);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };
  onBackYesClick = () => {
    this.onUpTimeSave();
    this.setState({
      showConfirmBack: false
    });
  };
  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  render() {
    const {
      translate,
      classes,
      isTestEdit,
      uptimedetails,
      upTime,
      testEdit,
      modified
    } = this.props;
    const {
      isChanged,
      errors,
      bandwidthtype,
      linkspeed,
      desiredbandwidth,
      desiredbandwidthpercenatge,
      certainty,
      durH,
      durM,
      durS,
      desireduptimecertainty,
      limitpercentage,
      framesize,
      expectedtotalbandwidth,
      expectedusablebandwidth,
      networkoverhead,
      isRestore
    } = this.state;
    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("general_sub_test_uptime")}
          />
        )}
        <Content translate={translate}>
          {/* <div className={classes.mainBody}> */}
          {upTime && (linkspeed && linkspeed != null) && (
            <Grid container>
              <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
              <Grid item xs={!isTestEdit ? 8 : 12}>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      select
                      name={"bandwidthtype"}
                      value={
                        bandwidthtype && bandwidthtype.length
                          ? bandwidthtype[0].value
                          : bandwidthtype
                      }
                      onChange={this.onChange}
                      error={false}
                      label={translate("uptime_bandwidth")}
                      margin="normal"
                      fullWidth
                    >
                      {BandWidthTypeEnum.map(item => {
                        return (
                          <MenuItem key={item.key} value={item.value}>
                            {item.key}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors && errors.linkspeed ? true : false}
                      name="linkspeed"
                      label={translate("uptime_linkspeed")}
                      margin="normal"
                      value={
                        bandwidthtype == 0 || bandwidthtype == 1
                          ? 10
                          : linkspeed
                      }
                      disabled
                      helperText={
                        errors && errors.linkspeed ? errors.linkspeed : ""
                      }
                      onChange={this.onChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors.desiredbandwidth}
                      name="desiredbandwidth"
                      label={translate("uptime_desired_bandwidth")}
                      margin="normal"
                      value={desiredbandwidth}
                      disabled={bandwidthtype == 0}
                      helperText={
                        errors && errors.desiredbandwidth
                          ? errors.desiredbandwidth
                          : ""
                      }
                      onChange={this.onChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors.desiredbandwidthpercenatge}
                      name="desiredbandwidthpercenatge"
                      label={translate("uptime_bandwidth_per")}
                      margin="normal"
                      value={desiredbandwidthpercenatge}
                      disabled={bandwidthtype == 1}
                      helperText={
                        errors && errors.desiredbandwidthpercenatge
                          ? errors.desiredbandwidthpercenatge
                          : ""
                      }
                      onChange={this.onChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.subheading}>
                      {translate("uptime_desired_title")}
                    </Typography>
                    <RadioGroup
                      aria-label=""
                      name="desireduptimecertainty"
                      value={desireduptimecertainty}
                      onChange={this.onChange}
                      row
                      className={classes.radiogrp}
                    >
                      <Grid item xs={6}>
                        <FormControlLabel
                          value={0}
                          control={
                            <Radio
                              checked={desireduptimecertainty == 0}
                              value={0}
                              name="radio-button-demo"
                              inputProps={{ "aria-label": "A" }}
                              onChange={this.onCertaintyChange}
                            />
                          }
                          label={translate("uptime_duration")}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          value={1}
                          control={
                            <Radio
                              checked={desireduptimecertainty == 1}
                              value={1}
                              name="radio-button-demo"
                              onChange={this.onCertaintyChange}
                            />
                          }
                          label={translate("uptime_certainty")}
                        />
                      </Grid>
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textFieldTime}
                      name={"durH"}
                      error={errors.duration}
                      margin="normal"
                      value={durH}
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 72 } }}
                      // helperText={
                      //   errors && errors.duration ? errors.duration : ""
                      // }
                      onChange={this.onDurationChange}
                      disabled={desireduptimecertainty == 1}
                    />
                    :
                    <TextField
                      className={classes.textFieldTime}
                      name={"durM"}
                      error={errors.duration}
                      margin="normal"
                      value={durM}
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 59 } }}
                      // helperText={
                      //   errors && errors.duration ? errors.duration : ""
                      // }
                      onChange={this.onDurationChange}
                      disabled={desireduptimecertainty == 1}
                    />
                    :
                    <TextField
                      className={classes.textFieldTime}
                      name={"durS"}
                      error={errors.duration}
                      margin="normal"
                      value={durS}
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 59 } }}
                      // helperText={
                      //   errors && errors.duration ? errors.duration : ""
                      // }
                      onChange={this.onDurationChange}
                      disabled={desireduptimecertainty == 1}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      select
                      name={"certainty"}
                      value={
                        certainty && certainty.length
                          ? certainty[0].value
                          : certainty
                      }
                      onChange={this.onChange}
                      error={false}
                      margin="normal"
                      disabled={desireduptimecertainty == 0}
                      fullWidth
                    >
                      {CertaintyEnum.map(item => {
                        return (
                          <MenuItem key={item.key} value={item.value}>
                            {item.key}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>

                  <Grid item xs={6}>
                    {errors && errors.duration ? (
                      <Typography className={classes.subheading} color="error">
                        {translate("uptime_duration_error")}
                      </Typography>
                    ) : null}
                    <TextField
                      className={classes.textField}
                      error={errors.limitpercentage}
                      name="limitpercentage"
                      label={translate("uptime_limit_per")}
                      margin="normal"
                      value={limitpercentage}
                      helperText={
                        errors && errors.limitpercentage
                          ? errors.limitpercentage
                          : ""
                      }
                      onChange={this.onChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}>
                    <TextField
                      select
                      name={"framesize"}
                      value={
                        framesize && framesize.length
                          ? framesize[0].key
                          : framesize
                      }
                      label={translate("uptime_frame_size")}
                      onChange={this.onChange}
                      error={false}
                      margin="normal"
                      fullWidth
                    >
                      {FrameSizeEnum.map(item => {
                        return (
                          <MenuItem key={item.key} value={item.value}>
                            {item.key}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors.expectedtotalbandwidth}
                      name="expectedtotalbandwidth"
                      label={translate("uptime_total_bandwidth")}
                      margin="normal"
                      value={expectedtotalbandwidth}
                      helperText={
                        errors && errors.expectedtotalbandwidth
                          ? errors.expectedtotalbandwidth
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors.expectedusablebandwidth}
                      name="expectedusablebandwidth"
                      label={translate("uptime_usuable_bandwidth")}
                      margin="normal"
                      value={expectedusablebandwidth}
                      helperText={
                        errors && errors.expectedusablebandwidth
                          ? errors.expectedusablebandwidth
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textField}
                      error={errors.networkoverhead}
                      name="networkoverhead"
                      label={translate("uptime_nw_overhead")}
                      margin="normal"
                      value={networkoverhead}
                      helperText={
                        errors && errors.networkoverhead
                          ? errors.networkoverhead
                          : ""
                      }
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={12}>
                    {!isTestEdit && (
                      <div align="right">
                        <Button
                          disabled={!isChanged}
                          color="accent"
                          raised
                          mini
                          onClick={this.onUpTimeSave}
                          className={classes.saveTarget}
                        >
                          {translate("sub_set_ping_save_target")}
                        </Button>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: translate("general_sub_test_uptime_head")
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              //okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              //onOk={this.onTargetConfirmDelete}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>

        {isTestEdit && upTime && (linkspeed && linkspeed != null) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <div style={{ display: "inline-block", marginLeft: "20px" }}>
              {uptimedetails && !testEdit ? (
                <Button
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                  className={classes.restoreButton}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : testEdit && modified ? (
                <Button
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                  className={classes.restoreButton}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : null}
            </div>
            <div style={{ display: "inline-block", marginRight: "20px" }}>
              <Button
                disabled={!isChanged}
                color="accent"
                raised
                onClick={() => this.onUpTimeSave()}
                className={classes.saveTarget}
              >
                {translate("general_continue")}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}
export default withRouter(withStyles(styles)(UpTime));
